import {letterMgmtRestClient} from "../index";

const loadLetters = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getAllLetters();
  return response.data;
};

const loadMyModifiedLetters = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getMyModifiedLetters();
  return response.data;
};

const loadNewLetterCountsByLanguage = async () => {
  const response = await letterMgmtRestClient.letterMgmtApi().getNewLetterCountsByLanguage();
  return response.data;
};

const loadLettersPaginated = async (data, options) => {
  const page = data?.page || 0;
  const size = data?.size || 10;
  const sort = data?.sort || undefined;
  const search = data?.search || undefined;
  const language = data?.language && data.language.length > 0 ? data.language : undefined;
  const status = data?.status && data.status.length > 0 ? data.status : undefined;

  const response = await letterMgmtRestClient.letterMgmtApi().getAllLettersPaginated(
    page,
    size,
    sort,
    search,
    language,
    status,
    options
  );
  return response.data;
};

const searchLetters = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().searchLetters(data.search);
  return response.data;
};

const loadLetter = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getLetter(data.id);
  return response.data;
};

const updateLetter = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().updateLetter(data.id, data.updatedLetter);
  return response.data;
};

const loadLettersByStack = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getAllLettersFromStacks(data.stackId);
  return response.data;
};


const loadRequestedStacks = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getAllStackRequests();
  return response.data;
};

const loadAllStacks = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getAllStacks(["REQUESTED", "ASSIGNED","DELIVERED", "SUBMITTED", "CLOSED"]);
  return response.data;
};

const loadAssignedStacks = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getAllStacks(["ASSIGNED"]);
  return response.data;
};

const loadDeliveredStacks = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getAllStacks(["DELIVERED", "SUBMITTED"]);
  return response.data;
};

const loadClosedStacks = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getAllStacks(["CLOSED"]);
  return response.data;
};

const loadAllNotAnsweredStacks = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getAllStacksNotAnswered();
  return response.data;
};

const loadStaffMembers = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getAllStaffMember();
  return response.data;
};

const loadMyStacks = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getAllMyStacks();
  return response.data;
};

const createStackRequest = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().createStackRequest(data.requestedStack);
  return response.data;
};

const assignStack = async (data) => {
  console.log("DATA IN", data)
  const response = await letterMgmtRestClient.letterMgmtApi().assignStack(data.assignedStack);
  return response.data;
};

const deliverStack = async (data) => {
  console.log("DATA IN", data)
  const response = await letterMgmtRestClient.letterMgmtApi().deliverStack(data.stackId);
  return response.data;
};

const submitStack = async (data) => {
  console.log("DATA IN", data)
  const response = await letterMgmtRestClient.letterMgmtApi().submitStack(data.stackId);
  return response.data;
};

const closeStack = async (data) => {
  console.log("DATA IN", data)
  const response = await letterMgmtRestClient.letterMgmtApi().closeStack(data.stackId);
  return response.data;
};

const closeAndCreateReviewStack = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().closeAndCreateReviewAnswerStack(data.stackId);
  return response.data;
};

const reopenStack = async (data) => {
  console.log("DATA IN", data)
  const response = await letterMgmtRestClient.letterMgmtApi().reopenStack(data.stackId);
  return response.data;
};

const rollbackReviewStack = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().rollbackReviewAnswerStack(data.stackId);
  return response.data;
};

const unassignStack = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().unassignStack(data.stackId);
  return response.data;
};

const reassignStack = async (data) => {
  console.log("DATA IN", data)
  const response = await letterMgmtRestClient.letterMgmtApi().reassignStack(data.stackId, data.staffMember);
  return response.data;
};

const extendStack = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().extendStack(data.stackId, data.extendStack);
  return response.data;
};

const joinStacks = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().joinStacks({stackIds: data.stackIds});
  return response.data;
};

const getStackRequest = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getStackRequestById(data.id);
  return response.data;
};

const getStack = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getStackById(data.id);
  return response.data;
};

const deleteStack = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().deleteStackById(data.id);
  return response.data;
};

const loadSummaries = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getAllSummaries();
  return response.data;
};

const searchSummaries = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().searchSummaries(data.search);
  return response.data;
};

const createSummary = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().createSummary(data.summary);
  return response.data;
};

const updateSummary = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().updateSummary(data.summary.id, data.summary);
  return response.data;
};

const updateAnswer = async (data) => {
    const response = await letterMgmtRestClient.letterMgmtApi().updateAnswer(data.answer.id, data.answer);
    return response.data;
}

const loadAnswers = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getAllAnswers();
  return response.data;
};

const searchAnswers = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().searchAnswers(data.search);
  return response.data;
};

const createAnswer = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().createAnswer(data.answer);
  return response.data;
};

const deleteSummary = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().deleteSummary(data.id);
  return response.data;
};

const deleteAnswer = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().deleteAnswer(data.id);
  return response.data;
};

const adoptSummary = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().adoptSummary(data.id);
  return response.data;
};

const adoptAnswer = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().adoptAnswer(data.id);
  return response.data;
};

const unadoptSummary = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().unadoptSummary(data.id);
  return response.data;
};

const unadoptAnswer = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().unadoptAnswer(data.id);
  return response.data;
};

const downloadAttachment = async (data) => {
  return await letterMgmtRestClient.attachmentApi().downloadAttachment(data.id, {responseType: 'arraybuffer'});
};

const downloadStackAttachment = async (data) => {
  return await letterMgmtRestClient.attachmentApi().downloadForStack(data.stackId, data.deliveryMethod, {responseType: 'arraybuffer'});
};

const downloadForLetterForHudhur = async (data) => {
  return await letterMgmtRestClient.attachmentApi().downloadForLetterForHudhur( {responseType: 'arraybuffer'});
};

const updateLetterMetadata = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().updateLetterMetadata(data.letterId, data.metadata);
  return response.data;
};

const cancelLetter = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().cancelLetter(data.id, data.comment);
  return response.data;
};

const presentToHudhur = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().toHudhur(data.id);
  return response.data;
};

const downloadLetter = async (data) => {
  return await letterMgmtRestClient.letterMgmtApi().downloadLetter(data.id, {responseType: 'arraybuffer'});
};

const downloadMultipleLetters = async (data) => {
  // Use the existing downloadMultipleLetters API endpoint
  if (data.ids && data.ids.length > 0) {
    return await letterMgmtRestClient.letterMgmtApi().downloadMultipleLetters(data.ids, {responseType: 'arraybuffer'});
  }
  throw new Error("No letter IDs provided for download");
};

// User Settings functions
const getAllUserSettings = async () => {
  const response = await letterMgmtRestClient.userSettingsApi().getAllUserSettings();
  return response.data;
};

const getUserSettings = async (data) => {
  const response = await letterMgmtRestClient.userSettingsApi().getUserSettings(data.settingName);
  return response.data;
};

const saveUserSettings = async (data) => {
  const response = await letterMgmtRestClient.userSettingsApi().saveUserSettings(data.userSettingsDto);
  return response.data;
};

// PAP-343: Suspension Notice (global switch relayed to the postbox)
const getSuspensionNotice = async () => {
  const response = await letterMgmtRestClient.suspensionNoticeApi().getSuspensionNotice();
  return response.data;
};

const updateSuspensionNotice = async (data) => {
  const response = await letterMgmtRestClient.suspensionNoticeApi().updateSuspensionNotice(data.suspensionNotice);
  return response.data;
};

const deleteUserSettings = async (data) => {
  const response = await letterMgmtRestClient.userSettingsApi().deleteUserSettings(data.settingName);
  return response.data;
};

// Comment functions
const addComment = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().addComment(data.id, data.newCommentDto);
  return response.data;
};

const editComment = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().editComment(data.id, data.commentDto);
  return response.data;
};

const deleteComment = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().deleteComment(data.id);
  return response.data;
};

const updateStackSummaryOrder = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().updateStackSummaryOrder(data.id, data.requestBody);
  return response.data;
};

const addInstructions = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().addInstructions(data);
  return response.data;
};

const reviewLetter = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().reviewLetter(data.letterId, data.reviewDto);
  return response.data;
};

const uploadCustomPdf = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().uploadModifiedAnswerPdf(data.letterId, data.file);
  return response.data;
};

const resetToOriginalAnswerPdf = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().resetToOriginalAnswerPdf(data.letterId);
  return response.data;
};

const retryDelivery = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().retryDelivery(data.letterId, { deliveryMethod: data.deliveryMethod });
  return response.data;
};

const submitReviewStack = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().submitStack(data.stackId);
  return response.data;
};

const getLetterDownloadHistory = async (data) => {
  const response = await letterMgmtRestClient.letterMgmtApi().getLetterDownloadHistory(data.letterId);
  return response.data;
};

const letterMgmtRestService = {
  loadLetters,
  loadLettersPaginated,
  loadNewLetterCountsByLanguage,
  loadMyModifiedLetters,
  searchLetters,
  loadRequestedStacks,
  loadClosedStacks,
  loadAllNotAnsweredStacks,
  loadAssignedStacks,
  loadDeliveredStacks,
  loadAllStacks,
  updateLetter,
  updateLetterMetadata,
  assignStack,
  reassignStack,
  extendStack,
  joinStacks,
  unassignStack,
  deliverStack,
  submitStack,
  closeStack,
  closeAndCreateReviewStack,
  reopenStack,
  rollbackReviewStack,
  downloadStackAttachment,
  downloadAttachment,
  downloadMultipleLetters,
  downloadForLetterForHudhur,
  downloadLetter,
  loadStaffMembers,
  createStackRequest,
  getStack,
  getStackRequest,
  deleteStack,
  loadMyStacks,
  loadLettersByStack,
  loadLetter,
  loadSummaries,
  searchSummaries,
  createSummary,
  updateSummary,
  loadAnswers,
  searchAnswers,
  createAnswer,
  updateAnswer,
  deleteSummary,
  deleteAnswer,
  adoptSummary,
  adoptAnswer,
  unadoptSummary,
  unadoptAnswer,
  cancelLetter,
  presentToHudhur,
  getAllUserSettings,
  getUserSettings,
  saveUserSettings,
  deleteUserSettings,
  addComment,
  editComment,
  deleteComment,
  updateStackSummaryOrder,
  addInstructions,
  reviewLetter,
  uploadCustomPdf,
  resetToOriginalAnswerPdf,
  retryDelivery,
  submitReviewStack,
  getLetterDownloadHistory,
  getSuspensionNotice,
  updateSuspensionNotice
};

export default letterMgmtRestService;